import { createContext, useContext, useState, useCallback } from 'react';

const UserContext = createContext();

const DEFAULT_USER = {
  id: 'currentUser',
  name: '我',
  avatar: null,
  bio: '这个人很懒，什么都没留下',
  tags: ['编程', '摄影'],
};

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('currentUser');
    return saved ? JSON.parse(saved) : DEFAULT_USER;
  });

  const updateUser = useCallback((updates) => {
    setUser((prev) => {
      const next = { ...prev, ...updates };
      localStorage.setItem('currentUser', JSON.stringify(next));
      return next;
    });
  }, []);

  return (
    <UserContext.Provider value={{ user, updateUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
